module.exports = __webpack_public_path__ + "static/media/thumb-up-solid.588dab46.svg";